import { BLOG_URL_PATTERN, DASHBOARD_URL_PATTERN, THANK_YOU_URL_PATTERN } from '../config.js';

export type PageCategory = 'blog' | 'dashboard' | 'thank-you' | 'public';

/**
 * Détermine la catégorie d'une page à partir de son pathname.
 * Ordre de priorité : thank-you > blog > dashboard > public.
 */
export function categorizePage(pathname: string = window.location.pathname): PageCategory {
  if (pathname.includes(THANK_YOU_URL_PATTERN)) return 'thank-you';
  if (pathname.includes(BLOG_URL_PATTERN)) return 'blog';
  if (pathname.includes(DASHBOARD_URL_PATTERN)) return 'dashboard';
  return 'public';
}
